export default "__VITE_ASSET__BhuRJJ1I__"